import React from 'react';

import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

import { TableOfContentsButtonPlaceholder } from '@confluence/floating-table-of-contents-common/entry-points/tableOfContentsButtonPlaceholder.ts';

import type { TableOfContentsPopupButton } from './TableOfContentsPopupButton.tsx';

export const TableOfContentsPopupButtonLoader: LoadableType<
	React.ComponentProps<typeof TableOfContentsPopupButton>
> = LoadableAfterPaint({
	loading: () => <TableOfContentsButtonPlaceholder />,
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TableOfContentsPopupButton" */ './TableOfContentsPopupButton.tsx'
			)
		).TableOfContentsPopupButton,
});
